import {callAjaxGet} from "../../utils";

export const fetchUserCargos = async (userID, errorHandling) => {
    const data = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/usuarios/${userID}/cargos`, errorHandling);
   // console.log(`${process.env.REACT_APP_API_URL}/usuarios/${userID}/cargos`)

    // Ajustamos los cargos para separar el camelcase
    const normalizedData = data.items.map(crg => {
        return {
            ...crg,
            cargo: crg.cargo.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
        }
    });

    // Agrupamos tabla de cargo
    return normalizedData.reduce((acc, value) => {
        if (!acc[value.cargoTableType]) {
            acc[value.cargoTableType] = [];
        }

        acc[value.cargoTableType].push(value);
        return acc;
    }, {province: [], community: [], workgroup: [], mission: []});
}